module.exports = __webpack_public_path__ + "static/media/slack_02.62b32926.jpg";